

class MarQuee{


    constructor(dom){
        this.dom=dom;
        this.x=0;
        this.speed=1;
        
        window.addEventListener("resize",function(){
            
            this.resize();

        }.bind(this))
        this.resize();
        this.interval=setInterval(function(){

            this.animate();
        }.bind(this),30)
                
                /*var clone = text.cloneNode(true);
                marquee.appendChild(clone);
                var w=clone.getBoundingClientRect().width;
                var c=0;
                while(c*w<window.innerWidth*2){
                    marquee.appendChild(clone);
                    
                    clone = text.cloneNode(true);
                    

                    
                    c++;
                    if(c>20){
                        break;

                    }
                }

                let start = null;
                const speed = 1; // px per second
                let POS=0;
                function animate() {
                    
                    POS-=speed;

                    var m=(marquee.children[1]);
                    var left=(m.getBoundingClientRect().left);
                    if(left<0){
                        console.log("YLI");
                        POS=left;
                    }

                    marquee.style.transform = `translateX(${POS}px)`;
                    


                }
                setInterval(function(){

                    animate();
                },30)
*/


    }
    animate(){
    
        this.x-=this.speed;
        var m=(this.dom.children[1]);
        
        if(m){
        var left=(m.getBoundingClientRect().left);
        if(left<0){
            
            this.x=left;
        }
        this.dom.style.transform = `translateX(${this.x}px)`;
    }
    }
    resize(){
        var text = this.dom.querySelector(".text");
        var w=text.getBoundingClientRect().width;
       

        var c= this.dom.querySelectorAll(".text").length;
        //console.log(w);
        while(c*w<window.innerWidth*2 || c<2){
            var clone = text.cloneNode(true);
            this.dom.appendChild(clone);
        
            
        

            
            c++;
            if(c>50){
                console.log("LIMIT");
                break;

            }
        }
            //console.log("cloned",c);



        
    }
}








function makeBg(){

const canvas = document.getElementById('glcanvas');
const gl = canvas.getContext('webgl');
if (!gl) console.log("WebGL not supported");
canvas.style.display="";

let points = [];

function resizeCanvas() {
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  gl.viewport(0, 0, canvas.width, canvas.height);
}
window.addEventListener('resize', resizeCanvas);
resizeCanvas();

// Vertex shader
const vsSource = `
  attribute vec2 aPosition;
  void main() {
    gl_Position = vec4(aPosition, 0.0, 1.0);
  }
`;

// Fragment shader (Gaussian falloff)
const fsSource = `
  precision highp float;
  uniform vec2 uResolution;
  uniform int uPointCount;
  uniform vec3 uPoints[100];
  uniform vec4 uColors[100];

  void main() {
    vec2 uv = gl_FragCoord.xy;
    vec3 accumulatedColor = vec3(0.0);
    float totalWeight = 0.0;

    for (int i = 0; i < 100; i++) {
      if (i >= uPointCount) break;

      vec2 p = uPoints[i].xy;
      float radius = uPoints[i].z;
      vec4 color = uColors[i];

      float dist = distance(uv, p);
      float strength = exp(-pow(dist / radius, 2.0)); // Gaussian falloff

      accumulatedColor += color.rgb * strength;
      totalWeight += strength;
    }

    vec3 finalColor = (totalWeight > 0.0) ? accumulatedColor / totalWeight : vec3(0.0);
    gl_FragColor = vec4(finalColor, 1.0);
  }
`;

// Shader helpers
function createShader(type, source) {
  const shader = gl.createShader(type);
  gl.shaderSource(shader, source);
  gl.compileShader(shader);
  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
    console.error(gl.getShaderInfoLog(shader));
    return null;
  }
  return shader;
}

const vs = createShader(gl.VERTEX_SHADER, vsSource);
const fs = createShader(gl.FRAGMENT_SHADER, fsSource);
const program = gl.createProgram();
gl.attachShader(program, vs);
gl.attachShader(program, fs);
gl.linkProgram(program);
gl.useProgram(program);

// Quad buffer
const vertices = new Float32Array([
  -1, -1,
   1, -1,
  -1,  1,
   1,  1
]);
const buffer = gl.createBuffer();
gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);

const aPosition = gl.getAttribLocation(program, 'aPosition');
gl.enableVertexAttribArray(aPosition);
gl.vertexAttribPointer(aPosition, 2, gl.FLOAT, false, 0, 0);

const uResolution = gl.getUniformLocation(program, 'uResolution');
const uPointCount = gl.getUniformLocation(program, 'uPointCount');
const uPoints = gl.getUniformLocation(program, 'uPoints[0]');
const uColors = gl.getUniformLocation(program, 'uColors[0]');

function hexToRgb(hex) {
  const bigint = parseInt(hex.slice(1), 16);
  return [
    ((bigint >> 16) & 255) / 255,
    ((bigint >> 8) & 255) / 255,
    (bigint & 255) / 255
  ];
}

function addPoint(x, y, radius, colorHex) {
  const rgb = hexToRgb(colorHex);
  points.push({
    baseX: x,
    baseY: y,
    baseRadius: radius,
    x,
    y,
    radius,
    color: [...rgb, 1.0],
    offset: Math.random() * Math.PI * 2 // random phase for movement
  });
}

// Initial points
addPoint(0, window.innerHeight, 500, "#FB6161");
addPoint(window.innerWidth, 0, 500, "#F99370");
addPoint(window.innerWidth * 0.75, 0, 300, "#33A3FF");

function draw() {
  gl.clearColor(0, 0, 0, 1);
  gl.clear(gl.COLOR_BUFFER_BIT);

  const flatPoints = [];
  const flatColors = [];
  points.forEach(p => {
    flatPoints.push(p.x, p.y, p.radius);
    flatColors.push(...p.color);
  });

  gl.uniform2f(uResolution, canvas.width, canvas.height);
  gl.uniform1i(uPointCount, points.length);
  gl.uniform3fv(uPoints, new Float32Array(flatPoints.concat(new Array((100 - points.length) * 3).fill(0))));
  gl.uniform4fv(uColors, new Float32Array(flatColors.concat(new Array((100 - points.length) * 4).fill(0))));

  gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
}

function animate(time) {
  points.forEach(p => {
  //  p.x = p.baseX + Math.sin(time * 0.001 + p.offset) * 110;
  //  p.y = p.baseY + Math.cos(time * 0.001 + p.offset) * 110;
    p.radius = p.baseRadius + Math.sin(time * 0.00015 + p.offset) * 100;
  });

  draw();
  requestAnimationFrame(animate);
}

animate(0);

} 

class App {

	constructor() {
		document.addEventListener('DOMContentLoaded', () => {
			this.start();
		});
	}

	/**
	 * App entry point
	 */
	start() {
		
		makeBg();

     const marquees = document.querySelectorAll(".wp-block-haiven-marquee .track");
        
        for(var i=0;i<marquees.length;i++){
            new MarQuee(marquees[i]);
            
        }


	}
}

const app = new App();
